import React, { useEffect, useState } from 'react';
import { Tag, Typography } from 'antd';
import { routePaths } from 'router';
import { useGetManyInvoices } from 'api/invoices/use-get-many-invoices.ts';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useInvoiceFiltersStore } from 'shared/stores/use-invoices-filters.ts';
import { HighlightText } from 'components/common/highlight-text';
import { SearchFilter } from 'components/common/search-filter';
import styles from './invoices-search.module.scss';

export const InvoicesSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useInvoiceFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: invoices, isError } = useGetManyInvoices({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (invoices && !isError) {
      const values = invoices.data.map((invoice) => {
        const related = invoice.order || invoice.trip || invoice.warehouseTask;

        const clientOrderNumber = invoice.order
          ? invoice.order.clientOrderNumber
          : !invoice.trip
          ? invoice.warehouseTask?.clientOrderNumber
          : null;

        return {
          label: (
            <>
              <HighlightText highlight={searchString} strong>
                {related?.compositeId}
              </HighlightText>
              {clientOrderNumber && (
                <Tag className={styles.clientOrderNumberTag}>
                  <HighlightText highlight={searchString}>{clientOrderNumber}</HighlightText>
                </Tag>
              )}
              <Typography.Text className={styles.hintSecondaryInfo}> {invoice.price} €</Typography.Text>
            </>
          ),
          value: invoice.id,
        };
      });
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [invoices, isError, searchString]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.invoice, { invoiceId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
